// extracted by mini-css-extract-plugin
export default {"table":"ViewProducts_table__IKDDv","search":"ViewProducts_search__3fX1s","product-container":"ViewProducts_product-container__3+7dk","icons":"ViewProducts_icons__wSIYv"};